const selectors = {
  triggerBtn: "#choose-lenses",
  closeBtn: "#popup-close",
  popupWrapper: ".choose-lenses-wrapper",
  body: "body",
  goBackBtn: "#popup-goback",
  navItems: ".choose-lenses-nav-item",
  galleryMedia: ".product-gallery__thumbnail",
  popupMedia: ".choose-lenses-main-product img",
  chooseColour: ".choose-colour",
  readMoreeEls: "[data-readmore-content]",
  subtotalContainer: ".subtotal-container",
  subtotalProductImage: ".choose-lenses-subtotal-products img",
  subtotalPrice: ".choose-lenses-total-price .price",
  stepsPrice: ".subtotal-container-total .price",
  colorsWrapper: ".colors-wrapper",
  colorEl: ".color-el",
  chooseLensesEdit: ".choose-lenses-edit",
  extraProduct: ".extra-product",
  errorMsg: ".error-cart-msg",
  mainProductId: "input[name='id']",
  mainProductQuantity: ".choose-lenses-total-quantity input",
  additionalPopupWrapper: ".additional-popup-wrapper",
  additionalPopupContainer: ".additional-popup-container",
  popupAtcBtn: ".atc-next-step",
  popupCheckoutBtn: ".popup-checkout-btn",
  steps: ".choose-lenses-step",
  step_1: "#step-1",
};

const colorMap = {
  Grey: "#b7b7b7",
  Brown: "#8f845f",
  Green: "#717f74",
};

const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);

const triggerBtn = $(selectors.triggerBtn);
const closeBtn = $(selectors.closeBtn);
const popupWrapper = $(selectors.popupWrapper);
const body = $(selectors.body);
const goBackBtn = $(selectors.goBackBtn);
const additionalPopupWrapper = $(selectors.additionalPopupWrapper);
const additionalPopupContainer = $(selectors.additionalPopupContainer);
const popupAtcBtn = $(selectors.popupAtcBtn);
const popupMedia = $(selectors.popupMedia);
const subtotalContainer = $(selectors.subtotalContainer);
const step_1 = $(selectors.step_1);
const popupCheckoutBtn = $(selectors.popupCheckoutBtn);
const mainProductId = $(selectors.mainProductId);
const mainProductQuantity = $(selectors.mainProductQuantity);
const subtotalProductImage = $(selectors.subtotalProductImage);
const errorMsg = $(selectors.errorMsg);
const subtotalPrice = $(selectors.subtotalPrice);
const stepsPrice = $(selectors.stepsPrice);

const chooseLensesEdit = $$(selectors.chooseLensesEdit);
const extraProduct = $$(selectors.extraProduct);
const readMoreeEls = $$(selectors.readMoreeEls);
const chooseColour = $$(selectors.chooseColour);
const steps = $$(selectors.steps);
const navItems = $$(selectors.navItems);
const galleryMedia = $$(selectors.galleryMedia);

let formData = [];
const selectedExtras = [];
const mainPrice = Number(popupWrapper?.dataset.productPrice || 0);

// Custom Tracking Variables
let bypassRxStep = false;
let selectedRxMethod = "";
let isMigraineRxFlow = false; 
let selectedLensType = ""; // <-- ADD THIS NEW VARIABLE

// Generate Dropdown Options for Rx
function populateRxDropdowns() {
  const generateOptions = (selectId, min, max, isAxis) => {
    const select = document.getElementById(selectId);
    if (!select) return;
    
    // Create the default placeholder option
    let html = `<option value="" disabled selected>${isAxis ? '0' : '0.00'}</option>`;
    
    if (isAxis) {
      html += `<option value="None">None</option>`;
      for (let i = 0; i <= 180; i++) {
        html += `<option value="${i}">${i}</option>`;
      }
    } else {
      // SPH and CYL: Iterate using integer math (*100) to avoid JS decimal floating point errors
      for (let i = max * 100; i >= min * 100; i -= 25) {
        let val = (i / 100).toFixed(2);
        if (i > 0) val = "+" + val; // Add the positive sign for plus prescriptions
        html += `<option value="${val}">${val}</option>`;
      }
    }
    select.innerHTML = html;
  };

  // Run the generators with your exact clinical boundaries
  generateOptions('rx_od_sph', -10, 8, false);
  generateOptions('rx_os_sph', -10, 8, false);
  generateOptions('rx_od_cyl', -5, 5, false);
  generateOptions('rx_os_cyl', -5, 5, false);
  generateOptions('rx_od_axis', 0, 180, true);
  generateOptions('rx_os_axis', 0, 180, true);
}
populateRxDropdowns();

triggerBtn?.addEventListener("click", () => {
  let mainMediaSrc = popupWrapper.dataset.mainImage;

  if (window.product && window.product.variants && window.currentVariantId) {
    let selectedVariant = window.product.variants.find(v => v.id == window.currentVariantId);
    if (selectedVariant && selectedVariant.featured_image) {
      mainMediaSrc = selectedVariant.featured_image.src;
    }
  }

  if (mainMediaSrc) {
    popupMedia.src = mainMediaSrc;
    subtotalProductImage.src = mainMediaSrc;
  }

  popupWrapper.style.display = "block";
  body.style.overflow = "hidden";
});

closeBtn?.addEventListener("click", () => {
  popupWrapper.style.display = "none";
  body.style.overflow = "unset";
});

function updateBackButton(nextStep = null) {
  const activeNavItems = $$(selectors.navItems);
  const allSteps = $$(selectors.steps);
  const stepOrderIds = ["step-1", "step-prescription", "step-2", "step-3", "step-4", "step-5"];

  if (nextStep) {
    let targetId = `step-${nextStep}`;
    if (nextStep === "prescription") targetId = "step-prescription";

    let targetIndex = stepOrderIds.indexOf(targetId);

    activeNavItems.forEach((item, index) => {
      item.classList.toggle("active", index <= targetIndex);
    });

    allSteps.forEach((step) => {
      step.classList.toggle("active", step.id === targetId);
    });
  }

  const activeStep = $(".choose-lenses-step.active");
  const activeId = activeStep ? activeStep.id : "";

  if (activeId === "step-1") {
    formData = [];
    extraProduct.forEach((el) => {
      el.querySelector("input").checked = false;
    });
  }
  
  if (activeId === "step-4") {
    const selected = Array.from(extraProduct).some(el => el.querySelector("input:checked"));
    popupAtcBtn.textContent = selected ? "Add to cart" : "Skip";
  }
  
  if (activeId === "step-5") {
    popupAtcBtn.textContent = "Add to cart";
  }

  goBackBtn.classList.toggle("active", activeId !== "step-1");
  subtotalContainer.classList.toggle("active", activeId !== "step-1");
  popupAtcBtn.classList.toggle("active", ["step-4", "step-5"].includes(activeId));
  subtotalContainer.classList.toggle("active_summary", activeId === "step-5");
}

function displayFormData() {
  const summaryEls = document.querySelectorAll(".choose-lenses-subtotal-info-el");

  summaryEls.forEach((el) => {
    el.style.display = "none";
  });

  formData.forEach((entry) => {
    const key = Object.keys(entry)[0];
    const data = entry[key];

    summaryEls.forEach((el) => {
      const label = el.querySelector("p > b");
      const span = el.querySelector("p > span");

      if (!label || !span) return;

      const labelText = label.textContent.trim().replace(":", "").toLowerCase();
      const keyText = key.trim().toLowerCase();

      if (labelText.includes("extra") && keyText.includes("extra")) {
        if (Array.isArray(data.extras) && data.extras.length > 0) {
          const extrasTitles = data.extras.map((extra) => extra.title).join(", ");
          span.textContent = extrasTitles;
          el.style.display = "";
        }
      } else if (labelText === keyText) {
        if (data.title) {
          span.textContent = data.title;
          el.style.display = "";
        }
      }
    });
  });
}

function getMappedColor(colorName) {
  const key = Object.keys(colorMap).find(
    (k) => k.toLowerCase() === colorName.trim().toLowerCase()
  );
  return key ? colorMap[key] : colorName.trim();
}

function selectColor(el, parentWrapper) {
  let variant_id = +el.dataset.variantId;
  const colorEl = $$(selectors.colorEl);
  const colorsWrapper = $(selectors.colorsWrapper);
  let parentEl = parentWrapper.previousElementSibling;

  colorEl.forEach((el) => {
    if (+el.dataset.variantId === variant_id) {
      el.querySelector("span").style.border = "3px solid white";
      el.querySelector("span").style.boxShadow = `0 0 0 3px ${getMappedColor(el.textContent)}`;
      colorsWrapper.querySelector("p").innerHTML = `You selected <em>${el.textContent.toUpperCase()}</em> color`;
      colorsWrapper.querySelector("button").style.display = "block";
      colorsWrapper.querySelector("button").addEventListener("click", () => {
        additionalPopupWrapper.style.display = "none";
        parentEl.dataset.variantId = el.dataset.variantId;
        parentEl.dataset.price = el.dataset.price;
        parentEl.querySelector(".choose-lenses-step-item-title span").textContent = ` - ${el.textContent}`;
        parentEl.click();
      });
    } else {
      el.querySelector("span").style.border = "unset";
      el.querySelector("span").style.boxShadow = "unset";
    }
  });
}

function initializeAdditionalPopup(el, type) {
  if (type === "readmore") {
    additionalPopupWrapper.style.display = "flex";
    additionalPopupContainer.innerHTML = el.dataset.readmoreContent;
  } else if (type === "color") {
    additionalPopupWrapper.style.display = "flex";
    let variantInfo = JSON.parse(el.dataset.variantsInfo);
    let stepTitle = el.dataset.stepTitle.toLowerCase();
    let colorsContent = document.createElement("div");
    colorsContent.innerHTML = `  
  <div class="colors-wrapper">
    <span class="colors-title">Choose your ${stepTitle} color</span>
    <div class="colors-els">
      ${variantInfo.map((variant) => `
          <div class="color-el" data-variant-id="${variant.id}" data-color="${variant.title}" data-price="${variant.price}" style="cursor:pointer">
            <span style="background-color:${getMappedColor(variant.title)};"></span>
            ${variant.title}
          </div>
        `).join("")}
    </div>
    <p></p>
    <button style="display:none">Continue</button>
  </div>`;
    additionalPopupContainer.innerHTML = colorsContent.innerHTML;

    const colorEl = $$(selectors.colorEl);
    colorEl.forEach((colorEl) => {
      colorEl.addEventListener("click", () => {
        selectColor(colorEl, el);
      });
    });
  }
  additionalPopupWrapper.addEventListener("click", (el) => {
    if (el.target.classList.contains("additional-popup-wrapper") || el.target.classList.contains("close-btn")) {
      additionalPopupWrapper.style.display = "none";
      additionalPopupContainer.innerHTML = "";
    }
  });
}

function recalculateSubtotal() {
  let mainPrice = 0;
  let additionalTotal = 0;

  const productWrapper = document.querySelector(".choose-lenses-wrapper");
  const defaultMainPrice = Number(productWrapper?.dataset.productPrice || 0);

  formData.forEach((step) => {
    const key = Object.keys(step)[0];
    if (key.toLowerCase().includes("extra")) return;

    const data = step[key];
    const price = Number(data.price || 0);
    const priceType = data.priceType;

    if (priceType === "main" && data.choused_on_step === "1") {
      mainPrice = price;
    } else if (priceType === "additional") {
      additionalTotal += price;
    }
  });

  if (mainPrice === 0 && defaultMainPrice > 0) {
    mainPrice = defaultMainPrice;
  }

  const selected = [];
  extraProduct.forEach((el) => {
    const input = el.querySelector("input:checked");
    if (input) {
      selected.push({
        id: input.id,
        title: el.querySelector(".extra-product-info p").textContent.trim(),
        price: +input.dataset.price,
      });
    }
  });

  const activeStep = $(".choose-lenses-step.active");
  if (activeStep && activeStep.id === "step-4") {
    popupAtcBtn.textContent = selected.length > 0 ? "Add to cart" : "Skip";
  }

  const extrasTotal = selected.reduce((sum, item) => sum + item.price, 0);
  const quantity = parseInt(mainProductQuantity.value) || 1;

  const subtotal = mainPrice * quantity + additionalTotal + extrasTotal;

  formData = formData.filter((entry) => Object.keys(entry)[0] !== "Extra products");
  if (selected.length) {
    formData.push({
      "Extra products": {
        choused_on_step: "4",
        extras: selected,
      },
    });
  }

  subtotalPrice.textContent = `${(subtotal / 100).toFixed(2)}`;
  stepsPrice.textContent = `${(subtotal / 100).toFixed(2)}`;
  subtotalPrice.dataset.originalPrice = subtotal;
  stepsPrice.dataset.originalPrice = subtotal;
}

function collectFormData(currentStep, stepTitle, price, priceType, title, lineProperties = null, variantId = null) {
  const cleanStepNumber = currentStep.replace("step-", "");
  
  formData = formData.filter((entry) => {
    const key = Object.keys(entry)[0];
    const data = entry[key];
    return data.choused_on_step !== cleanStepNumber;
  });

  const stepInfo = {
    [lineProperties ? "line_properties" : "variant_id"]: lineProperties || variantId,
    choused_on_step: cleanStepNumber,
    price: +price,
    priceType,
    title,
  };

  formData.push({
    [stepTitle]: stepInfo,
  });

  recalculateSubtotal();
}

function addToCart(redirectUrl = "/cart") {
  const mainId = mainProductId.value;
  const quantity = parseInt(mainProductQuantity.value) || 1;
  const properties = {};
  const extraItems = [];

  formData.forEach((entry) => {
    const key = Object.keys(entry)[0];
    const data = entry[key];

    if (key === "Prescription Input") {
       Object.assign(properties, data);
    } else if (data.variant_id) {
      extraItems.push({ id: data.variant_id, quantity: 1 });
    } else if (data.title) {
      properties[key] = data.title;
    } else if (Array.isArray(data.extras)) {
      data.extras
        .filter((extra) => extra.available !== false)
        .forEach((extra) => {
          extraItems.push({ id: extra.id, quantity: 1 });
        });
    }
  });

  const payload = new FormData();
  let itemIndex = 0;
  
  payload.append(`items[${itemIndex}][id]`, mainId);
  payload.append(`items[${itemIndex}][quantity]`, quantity);
  
  for (const [key, value] of Object.entries(properties)) {
      if (value instanceof File) {
          payload.append(`items[${itemIndex}][properties][${key}]`, value, value.name);
      } else {
          payload.append(`items[${itemIndex}][properties][${key}]`, value);
      }
  }
  
  extraItems.forEach(item => {
      itemIndex++;
      payload.append(`items[${itemIndex}][id]`, item.id);
      payload.append(`items[${itemIndex}][quantity]`, item.quantity);
  });

  fetch("/cart/add.js", {
    method: "POST",
    body: payload, 
  })
    .then((response) => {
      if (!response.ok) throw new Error("Failed to add to cart");
      return response.json();
    })
    .then(() => {
      extraProduct.forEach((el) => { el.querySelector("input").checked = false; });
      mainProductQuantity.value = 1;
      if (redirectUrl) window.location.href = redirectUrl;
    })
    .catch((err) => {
      errorMsg.style.display = "block";
      errorMsg.textContent = err;
    });
}

goBackBtn?.addEventListener("click", () => {
  const activeStep = $(".choose-lenses-step.active");
  if (!activeStep) return;

  const currentId = activeStep.id;

  // Find what was saved to the cart data for Step 1
  let step1Choice = "";
  const step1Entry = formData.find(entry => Object.values(entry)[0]?.choused_on_step === "1");
  if (step1Entry) {
      step1Choice = Object.values(step1Entry)[0].title.trim().toLowerCase();
  }
  
  // Create an easy-to-read boolean for whether they chose Non-Prescription
  const isNonRx = step1Choice.includes("non-prescription");

  // 1. If on Step 4 and coming from Custom Rx Bypass -> Go back to Prescription
  if (currentId === "step-4" && isMigraineRxFlow) {
      updateBackButton("prescription");
  } 
  // 2. If on Step 4 and they chose Non-Prescription -> Go all the way back to Step 1
  else if (currentId === "step-4" && isNonRx) {
      updateBackButton(1);
  }
  // 3. Standard flow: If on Step 2 -> Go back to Prescription Step
  else if (currentId === "step-2" && !isNonRx) {
      updateBackButton("prescription");
  } 
  // 4. Standard flow: If on Prescription Step -> Go back to Step 1
  else if (currentId === "step-prescription") {
      updateBackButton(1);
  } 
  // 5. Catch-All for standard ordered backwards navigation
  else {
      const stepOrderIds = ["step-1", "step-prescription", "step-2", "step-3", "step-4", "step-5"];
      let currentIndex = stepOrderIds.indexOf(currentId);
      if (currentIndex > 0) {
          let prevStepId = stepOrderIds[currentIndex - 1];
          
          if (prevStepId === "step-prescription" && isNonRx) {
              prevStepId = "step-1";
          }
          let targetCleanId = prevStepId.replace("step-", "");
          updateBackButton(targetCleanId);
      }
  }

  errorMsg.style.display = "none";
  errorMsg.textContent = "";
  recalculateSubtotal();
});

steps?.forEach((el) => {
  let stepTitle = el?.querySelector(".product-title span")?.textContent;
  let currentStep = el.id;

  el.querySelectorAll(".choose-lenses-step-item").forEach((step) => {
    step.addEventListener("click", (e) => {
      if (e.target.classList.contains("choose-lenses-step-readmore") || e.currentTarget.classList.contains('rx-opt-card')) return;

      const target = e.currentTarget;
      const nextStep = target.dataset.nextStep;
      const lineProperties = target.dataset.lineProperties;
      const variantId = target.dataset.variantId;
      const price = target.dataset.price;
      const priceType = target.dataset.priceType;
      const title = target.querySelector("span").textContent;

      collectFormData(currentStep, stepTitle, price, priceType, title, lineProperties, variantId);

      // Routing rule interceptor with Geo-Routing
      if (currentStep === "step-1") {
        const userCountry = popupWrapper.dataset.country; // Gets 'CA', 'GB', 'US', etc.
        
      // Skip the Rx and Thickness screens if they chose Non-Prescription
        if (title.toLowerCase().includes("non-prescription") ) {
          bypassRxStep = true;
          
          // 1. Hide the current step
          document.querySelector('.choose-lenses-step.active')?.classList.remove('active');
          
          // 2. Jump directly to the Extras Step (Step 4)
          // NOTE: Adjust 'step-4' to whatever ID your Extras step actually uses in the HTML
          const extrasStep = document.getElementById('step-4') || document.getElementById('step-extras');
          if (extrasStep) extrasStep.classList.add('active');
          
          // 3. Update the back button to know we are on step 4
          updateBackButton(4);
          
        } else {
          bypassRxStep = false;
          
          // Proceed normally to the Prescription step
          document.querySelector('.choose-lenses-step.active')?.classList.remove('active');
          const rxStep = document.getElementById('step-prescription') || document.getElementById('step-2');
          if (rxStep) rxStep.classList.add('active');
          
          updateBackButton("prescription");
        }
      } else {
        updateBackButton(nextStep);
      }
      recalculateSubtotal();
    });
  });
});

document.querySelectorAll('.rx-opt-card').forEach(card => {
    card.addEventListener('click', function() {
        // Reset border and background colors for all cards
        document.querySelectorAll('.rx-opt-card').forEach(c => {
            c.style.borderColor = 'black';
            c.style.backgroundColor = 'transparent'; // Change 'black' if your default background is different (e.g., 'white' or 'transparent')
        });
        
        // Apply the active colors to the clicked card
        this.style.borderColor = '#abaaaa';
        this.style.backgroundColor = '#f5f5f5';
        
        selectedRxMethod = this.dataset.rxMethod;
        
        document.querySelector('.rx-manual-grid').style.display = (selectedRxMethod === 'manual') ? 'flex' : 'none';
        document.querySelector('.rx-input-field-container').style.display = (selectedRxMethod === 'upload') ? 'block' : 'none';
        
        document.getElementById('rx_continue_btn').style.display = 'block';
    });
});

// Toggle for Dual PD
document.getElementById('pd_type_toggle')?.addEventListener('change', function() {
    if (this.checked) {
        document.getElementById('single_pd_container').style.display = 'none';
        document.getElementById('dual_pd_container').style.display = 'flex';
    } else {
        document.getElementById('single_pd_container').style.display = 'block';
        document.getElementById('dual_pd_container').style.display = 'none';
    }
});

document.getElementById('rx_continue_btn')?.addEventListener('click', function() {
    let rxPayload = { "Prescription Method": selectedRxMethod };
    
    const isDualPd = document.getElementById('pd_type_toggle')?.checked;
    
    if (isDualPd) {
        const pdOd = document.getElementById('rx_pd_od').value;
        const pdOs = document.getElementById('rx_pd_os').value;
        if (pdOd.trim() !== "" || pdOs.trim() !== "") {
            rxPayload["Pupillary Distance (Right/OD)"] = pdOd;
            rxPayload["Pupillary Distance (Left/OS)"] = pdOs;
        }
    } else {
        const pdValue = document.getElementById('rx_pd').value;
        if (pdValue.trim() !== "") {
            rxPayload["Pupillary Distance (PD)"] = pdValue;
        }
    }
    
    if (selectedRxMethod === 'manual') {
        rxPayload["OD SPH"] = document.getElementById('rx_od_sph').value;
        rxPayload["OD CYL"] = document.getElementById('rx_od_cyl').value;
        rxPayload["OD AXIS"] = document.getElementById('rx_od_axis').value;
        rxPayload["OD ADD"] = document.getElementById('rx_od_add').value;
        rxPayload["OS SPH"] = document.getElementById('rx_os_sph').value;
        rxPayload["OS CYL"] = document.getElementById('rx_os_cyl').value;
        rxPayload["OS AXIS"] = document.getElementById('rx_os_axis').value;
        rxPayload["OS ADD"] = document.getElementById('rx_os_add').value;
    } else if (selectedRxMethod === 'upload') {
        const fileInput = document.getElementById('rx_file_input');
        if (fileInput.files.length > 0) {
            rxPayload["Prescription File"] = fileInput.files[0]; 
        } else {
            alert("Please select a file to upload, or choose a different method.");
            return; 
        }
    }
    
    formData = formData.filter(entry => !Object.keys(entry).includes("Prescription Input"));
    formData.push({ "Prescription Input": rxPayload });
    
    // --- READ DIRECTLY FROM FORMDATA MEMORY ---
    const productType = window.customProductType || ""; 
    
    // Find what was actually saved to the cart data for Step 1
    let step1Choice = "";
    const step1Entry = formData.find(entry => Object.values(entry)[0]?.choused_on_step === "1");
    if (step1Entry) {
        step1Choice = Object.values(step1Entry)[0].title.trim().toLowerCase();
    }

    // Skip to Extras IF product is Anti-Migraine OR the choice includes our exact sunglasses phrase
    if (productType.toLowerCase() === 'anti-migraine glasses' || step1Choice.includes('single vision prescription sunglasses')) {
        isMigraineRxFlow = true; 
        updateBackButton(4); 
    } else {
        isMigraineRxFlow = false;
        updateBackButton(2); 
    }
    
    recalculateSubtotal();
});

readMoreeEls.forEach((el) => {
  el.addEventListener("click", (el) => initializeAdditionalPopup(el.currentTarget, "readmore"));
});

chooseColour.forEach((el) => {
  el.addEventListener("click", (el) => initializeAdditionalPopup(el.currentTarget, "color"));
});

chooseLensesEdit.forEach((el, index) => {
  el.addEventListener("click", () => {
    const editMap = [1, 2, 3, 4];
    updateBackButton(editMap[index]);
  });
});

extraProduct.forEach((el) => {
  const input = el.querySelector("input");
  input.addEventListener("change", () => {
    recalculateSubtotal();
  });
});

mainProductQuantity.addEventListener("change", (input) => {
  if (+input.target.value <= 0) {
    input.target.value = 1;
  }
  recalculateSubtotal();
});

popupAtcBtn.addEventListener("click", () => {
  if (!subtotalContainer.classList.contains("active_summary")) {
    const selectedExtras = [];

    extraProduct.forEach((el) => {
      const input = el.querySelector("input:checked");
      if (input) {
        selectedExtras.push({
          id: input.id,
          title: el.querySelector(".extra-product-info p").textContent.trim(),
          price: +input.dataset.price,
        });
      }
    });

    const extraIndex = formData.findIndex((entry) => Object.keys(entry)[0] === "Extra products");

    if (extraIndex !== -1) {
      if (selectedExtras.length) {
        formData[extraIndex]["Extra products"].extras = selectedExtras;
      } else {
        formData.splice(extraIndex, 1);
      }
    } else if (selectedExtras.length) {
      formData.push({
        "Extra products": {
          choused_on_step: "4",
          extras: selectedExtras,
        },
      });
    }

    updateBackButton(5);
    displayFormData();
  } else {
    addToCart();
  }
});

popupCheckoutBtn.addEventListener("click", () => {
  addToCart("/checkout");
});